/** Keycloak resource roles for admin module access. */
export const ADMIN_ROLES = {
  SLANJE_TROSKOVA_ADMIN: 'slanje_troskova_admin',
  TEMPLATE_ADMIN: 'template_admin',
  LEKO_PREDMETI_ADMIN: 'leko_predmeti_admin',
} as const;

export type AdminRole = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];
